import React, { ReactNode, MouseEvent } from "react";
import ChildNavItem from "../../Sidebar/ChildNavItem";
import { EnumPaths } from "../../../utils/navigation";
import images from "../../../images";
import NavItem from "../../Sidebar/NavItem";
import history from "../../../history";
import { useOperatorDisplayConfiguration } from "../../../components/OperatorCustomization";

interface Props {
  children: ReactNode;
}

const CustomParametersTwoColumns = ({ children }: Props): JSX.Element => {
  const goToPage = (
    e: MouseEvent<HTMLDivElement | HTMLAnchorElement>,
    path: string
  ) => {
    e.preventDefault();
    history.push(path);
  };

  const isActive = (path: string): boolean => {
    return history.location.pathname === path;
  };

  const featureIncidents = useOperatorDisplayConfiguration([
    "sidebar.menu.management.incidents",
  ]);
  const featureQuotes = useOperatorDisplayConfiguration(["sidebar.menu.quote"]);

  const menus = [
    {
      text: "navbar.menu.operator",
      path: EnumPaths.OPERATOR,
      icon: "operator",
    },
    {
      text: "navbar.menu.attr_keys",
      path: EnumPaths.ATTRIBUTE_KEYS,
      icon: "attrKeys",
    },
    {
      text: "navbar.menu.price_unit_variations",
      path: EnumPaths.PRICE_UNIT_VARIATIONS,
      icon: "priceUnitVariations",
    },
    {
      text: "navbar.menu.payment_methods",
      path: EnumPaths.PAYMENT_METHODS,
      icon: "paymentMethods",
    },
    ...(featureIncidents
      ? [
          {
            text: "navbar.menu.incident_status",
            path: EnumPaths.INCIDENT_STATUS,
            icon: "incidentStatus",
          },
          {
            text: "navbar.menu.incident_types",
            path: EnumPaths.INCIDENT_TYPES,
            icon: "incidentTypes",
          },
        ]
      : []),
    ...(featureQuotes
      ? [
          {
            text: "navbar.menu.quote_request_status",
            path: EnumPaths.QUOTE_REQUEST_STATUS,
            icon: "quoteRequestStatus",
          },
          {
            text: "navbar.menu.quote_request_services",
            path: EnumPaths.QUOTE_REQUEST_SERVICES,
            icon: "quoteRequestServices",
          },
        ]
      : []),
  ];

  return (
    <main className="h-screen flex overflow-hidden pt-20">
      <div className="hidden md:flex md:flex-shrink-0 w-2/12">
        <div className="flex flex-col w-full bg-neutral-300">
          <div className="h-0 flex-1 flex flex-col overflow-y-auto w-full">
            <nav className="flex-1">
              <div className="py-5 divide-gray-200">
                <NavItem
                  id="menu_payment_methods"
                  index={0}
                  icon={images.nav_pilot_2}
                  text="navbar.menu.payment_methods"
                  withoutTitle
                >
                  {menus.map((item, index) => (
                    <ChildNavItem
                      key={index}
                      index={index}
                      text={item.text}
                      onClick={e =>
                        goToPage(e, `/${EnumPaths.ROOT}/${item.path}`)
                      }
                      isActive={isActive(`/${EnumPaths.ROOT}/${item.path}`)}
                      icon={item.icon}
                    />
                  ))}
                </NavItem>
              </div>
            </nav>
          </div>
        </div>
      </div>
      <div className="flex flex-col w-0 flex-1 overflow-hidden">
        <div
          id="scroll-container"
          className="m-0 flex-1 relative z-0 overflow-y-auto focus:outline-none bg-white"
        >
          <div className="dashboard-wrapper">{children}</div>
        </div>
      </div>
    </main>
  );
};

export default CustomParametersTwoColumns;
